module.exports = PropTypes;


//////////////////
// WEBPACK FOOTER
// external "PropTypes"
// module id = 0
// module chunks = 0